import remove from '@mailobj-browser/front/js/tree/remove.js'
import { handle } from './wrapper.js'

const { parseInt } = Number

const handler = (item, set, nb) => {
  const value = parseInt(nb.value, 10) - 1
  nb.value = `${value}`
  if (value === 0) {
    set.value = ''
  }
  remove(item)
}

export default button => {
  handle(button, handler)
}